/**
*
* FullscreenLoading
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Spinner from 'ui/Spinner';
import Text, { textShape } from 'ui/Text';
import { colors } from 'ui/constants';
import { calc } from 'utils/zoom';

const StyledContainer = styled.div`
  display: flex;
  height: ${calc('100vh')};
  width: ${calc('100vw')};
  justify-content: center;
  align-items: center;
  background: ${colors.white};
  z-index: 105;
  position: fixed;
  top: 0;
  left: 0;
  flex-direction: column;
`;

const LoadingText = styled(Text)`
  margin-top: 16px;
`;

function FullscreenLoading({ id, text }) {
  return (
    <StyledContainer id={id}>
      <Spinner />
      <LoadingText text={text} />
    </StyledContainer>
  );
}

FullscreenLoading.propTypes = {
  id: PropTypes.string,
  text: textShape,
};

FullscreenLoading.defaultProps = {
  id: null,
  text: null,
};

export default FullscreenLoading;
